module.exports = __webpack_public_path__ + "img/radar.347a7308.svg";